import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { ScrollToTop } from './components/ScrollToTop';
import { AlertBar } from './components/AlertBar';
import { Footer } from './components/Footer';
import { EspaceProvider } from './contexts/EspaceContext';
import { EspaceLayout } from './components/espace/EspaceLayout';
import { Accueil } from './pages/Accueil';
import { MaCarte } from './pages/MaCarte';
import { MesCollectes } from './pages/MesCollectes';
import { CalendrierCollectes } from './pages/CalendrierCollectes';
import { MonProfil } from './pages/MonProfil';
import { MesLoisirs } from './pages/MesLoisirs';
import { AvisNotifications } from './pages/AvisNotifications';
import { ParametresAvis } from './pages/ParametresAvis';
import { MesDemandes } from './pages/MesDemandes';
import { DemandeDetail } from './pages/DemandeDetail';
import { MonEspace } from './pages/MonEspace';
import { MesAnimaux } from './pages/MesAnimaux';
import { Plan } from './pages/Plan';
import { AnimalDetail } from './pages/AnimalDetail';
interface AppProps {
  showAlertBar?: boolean;
  showEvents?: boolean;
}
export function App({
  showAlertBar = true,
  showEvents = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3rd1bdndhtlq5">
      <EspaceProvider data-id="element-1" data-mp="3relumgucxi8p">
        <div id="accueil" className="min-h-screen w-full bg-white" data-id="element-2" data-mp="5os92t1uy7l">
          <ScrollToTop data-id="element-3" data-mp="82j0zgp5o9c" />
          <div className="sticky top-0 z-40" data-id="element-4" data-mp="2zld0746gb58w">
            <Header data-id="element-5" data-mp="2zmo557bmuj1l" />
            {showAlertBar && <AlertBar data-id="element-6" data-mp="33mou3lwcycmw" />}
          </div>
          <EspaceLayout data-id="element-7" data-mp="33nq73vwxp979">
            <Routes data-id="element-8" data-mp="33n6w6z5pbl2q">
              <Route path="/" element={<Accueil showEvents={showEvents} data-id="element-10" data-mp="38m1f013o59mu" />} data-id="element-9" data-mp="33oi2b5mmd4x0" />
              <Route path="/map" element={<Plan data-id="element-12" data-mp="38o4ct7b2c724" />} data-id="element-11" data-mp="38kgkucl9nspi" />
              <Route path="/my-card" element={<MaCarte data-id="element-14" data-mp="3dlnwimqj5c1g" />} data-id="element-13" data-mp="3dle46si0issl" />
              <Route path="/my-collections" element={<MesCollectes data-id="element-16" data-mp="nw2c461hdqr3" />} data-id="element-15" data-mp="3diry6xarslch" />
              <Route path="/my-collections/calendar" element={<CalendrierCollectes data-id="element-18" data-mp="sudksdg1hv7q" />} data-id="element-17" data-mp="nv0ybtt2yq5o" />
              <Route path="/my-profile" element={<MonProfil data-id="element-20" data-mp="swqbbezv5dwe" />} data-id="element-19" data-mp="stc864jdl0nw" />
              <Route path="/my-recreation" element={<MesLoisirs data-id="element-22" data-mp="356rh3pi3e8j" />} data-id="element-21" data-mp="3688rpx40wyp" />
              <Route path="/notifications" element={<AvisNotifications data-id="element-24" data-mp="3udazkg91d18e" />} data-id="element-23" data-mp="38b5essrpoce" />
              <Route path="/notifications/settings" element={<ParametresAvis data-id="element-26" data-mp="d4e4tqw8j8vn" />} data-id="element-25" data-mp="3uc9nq9k74apm" />
              <Route path="/my-requests" element={<MesDemandes data-id="element-28" data-mp="d2l6qzzotwz9" />} data-id="element-27" data-mp="d3cuxpqygsfi" />
              <Route path="/my-requests/:id" element={<DemandeDetail data-id="element-30" data-mp="864atjm8yebm" />} data-id="element-29" data-mp="851l3f0nuhxa" />
              <Route path="/my-dashboard" element={<MonEspace data-id="element-32" data-mp="3gklbm69y5m8n" />} data-id="element-31" data-mp="83qdt580as1f" />
              <Route path="/my-pets" element={<MesAnimaux data-id="element-34" data-mp="3gj1w4hw47f7x" />} data-id="element-33" data-mp="3glwabrojc3sw" />
              <Route path="/my-pets/:id" element={<AnimalDetail data-id="element-36" data-mp="3bnurn7v0u6hy" />} data-id="element-35" data-mp="3bn2ys4st6mvd" />
              <Route path="*" element={<Accueil showEvents={showEvents} data-id="element-38" data-mp="3qbpl4qgusew3" />} data-id="element-37" data-mp="3qb7hv9vrx0eo" />
            </Routes>
          </EspaceLayout>
          <Footer data-id="element-39" data-mp="3ljxukfxp695y" />
        </div>
      </EspaceProvider>
    </BrowserRouter>;
}